import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { city } = payload || {}

    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_CUSTOMERS, {
      queryParams: {
        city
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch customers',
        data: null,
      }
    }

    const customers = Array.isArray(raw.data) ? raw.data : (raw.data?.data || [])

    // 1. Formattage de la liste complète
    const formatted = customers.map(c => {
      console.log("🚀 ~ c:", c)
      // Extraction du nom (V3 utilise souvent profile.firstName/lastName)
      const firstName = c.profile?.firstName || c.firstName || '';
      const lastName = c.profile?.lastName || c.lastName || '';
      const fullName = (c.name || `${firstName} ${lastName}`).trim() || 'Client sans nom';
      
      // Extraction du solde (V3 utilise metadata.wallet.balance)
      const balance = c.balance || c.metadata?.wallet?.balance || 0;

      return {
        id: c.id,
        name: fullName,
        firstName: firstName,
        lastName: lastName,
        email: c.email || '',
        phoneNumber: c.phone || c.phoneNumber || c.profile?.phone || '',
        whatsapp: c.whatsapp || c.profile?.whatsapp || c.phone || c.phoneNumber || '',
        registrationNumber: c.numInsc || c.registrationNumber || c.id?.split('-')[0] || '',
        balance: balance,
        birthday: c.metadata?.birthday || c.birthday || c.profile?.birthday,
        orderStats: {
          totalOrders: c.orderStats?.totalOrders || 0,
          totalSpent: c.orderStats?.totalSpent || 0,
          avgOrderValue: c.orderStats?.averageOrderValue || 0,
          lastOrderDate: c.orderStats?.lastOrderDate
        },
        totalOrdersDelivered: c.orderStats?.totalOrders || 0,
        totalSpent: c.orderStats?.totalSpent || 0,
        lastPayment: c.orderStats?.lastOrderDate,
        createdAt: c.createdAt
      };
    })

    // 2. Application du filtre search si présent dans le payload
    const searchTerm = (payload?.search || '').trim().toLowerCase()

    const filtered = searchTerm
      ? formatted.filter(customer => {
          return (
            customer.name.toLowerCase().includes(searchTerm) ||
            customer.email.toLowerCase().includes(searchTerm) ||
            customer.phoneNumber.toLowerCase().includes(searchTerm) ||
            customer.whatsapp.toLowerCase().includes(searchTerm) ||
            customer.registrationNumber.toLowerCase().includes(searchTerm)
          )
        })
      : formatted

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    let finalData = filtered
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    // 3. Retour avec le total mis à jour selon le résultat du filtre
    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: filtered.length,
        result: paginated,
      },
    }
  },
}